var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExAudio)?_c('button',{staticClass:"obituary-audio_button",on:{"click":function($event){return _vm.$emit('mute')}}},[_c('img',{attrs:{"src":_vm.volumeMute
        ? require('@/assets/images/obituary/volume.png')
        : require('@/assets/images/obituary/volume_on.png')}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }